import { __read } from "tslib";
import { useRef, useState, useEffect, useCallback } from 'react';
import Fuse from 'fuse.js';
var defaultOptions = {
    keys: ['label', 'value'],
    threshold: 0.3,
};
export var useSearch = function (collection, callback, options, debounceTime) {
    if (options === void 0) { options = defaultOptions; }
    if (debounceTime === void 0) { debounceTime = 200; }
    var _a = __read(useState(null), 2), searchPhrase = _a[0], setSearchPhrase = _a[1];
    var fuseSearch = useRef(new Fuse(collection, options));
    var searchDebounce = useRef(null);
    var clearSearchPhrase = useCallback(function () {
        setSearchPhrase(null);
    }, []);
    useEffect(function () {
        fuseSearch.current = new Fuse(collection, options);
    }, [collection, options]);
    var searchHandler = useCallback(function (e) {
        var value = e.currentTarget.value;
        if (searchDebounce.current)
            clearTimeout(searchDebounce.current);
        searchDebounce.current = setTimeout(function () {
            var results = fuseSearch.current
                .search(value)
                .map(function (_a) {
                var item = _a.item;
                return item;
            });
            setSearchPhrase(value);
            callback(results, value);
        }, debounceTime);
    }, [fuseSearch, collection]);
    return {
        clearSearchPhrase: clearSearchPhrase,
        searchPhrase: searchPhrase,
        searchHandler: searchHandler,
    };
};
